import { useState } from 'react';
import { Link } from 'react-router-dom';
import '../../../css/VideoInfoCard.css';
import { Video } from '../../../interfaces/userInterfaces';
import { dateConverter } from '../../../services/formatDate.js';
import { useUser } from '../../../hooks/useUser';

export const VideoInfoCard = (videoInfo: Video) => {
  const [descriptionOpen, setDescriptionOpen] = useState(false);
  const { user } = useUser();

  const redirectRoute = () => {
    if (user?.username === videoInfo.username) {
      return '/profile';
    } else return `../profile/${videoInfo.id}`;
  };

  return (
    <section className="video-details">
      <span className="user-info">
        <Link to={redirectRoute()}>
          <img
            className="user-video-avatar"
            src={
              videoInfo?.profile?.avatar_url
                ? videoInfo?.profile?.avatar_url
                : 'https://nqbvdgzoxvmdlnjovyqu.supabase.in/storage/v1/object/public/avatars/default-avatar/userexpression.png'
            }
          ></img>
        </Link>
        <Link to={redirectRoute()} className="user-video-username">
          {videoInfo?.username}
        </Link>
      </span>
      <p className="video-description-title">Title: {videoInfo?.title}</p>
      <details
        onClick={() => setDescriptionOpen(!descriptionOpen)}
        className={
          descriptionOpen
            ? 'video-description-details-paragraph-open'
            : 'video-description-details-paragraph-closed'
        }
      >
        <summary>Description : </summary>
        {videoInfo?.description}
      </details>
      <p className="video-description-uploaded">Uploaded: {dateConverter(videoInfo?.created_at)}</p>
      <p className="view-count">Views: {videoInfo?.views}</p>
    </section>
  );
};
